export enum EElementType {
    EnergyBox,
    Gateway,
    Mast,
    SolarPanel,
    Unknown
}

export const elementsNameKey = [
    "elements.energy-box",
    "elements.gateway",
    "elements.mast",
    "elements.solar-panel",
    "elements.unknown"
];
